// https://dev.to/ms_yogii/useaxios-a-simple-custom-hook-for-calling-apis-using-axios-2dkj
import { useCallback } from 'react'
import axios from 'axios'

interface AxiosProps {
  url: string
  method?: 'get' | 'post' | 'put' | 'delete'
  data?: any
  headers?: any
}

const useAxios = ({ url, method = 'get', data = null, headers = null}: AxiosProps) => {
  return useCallback(() => {
    return axios({
      url,
      method,
      headers,
      data
    })
  }, [url, method, data, headers])
}

export default useAxios
